export const MAINMENU = "MainMenu";
export const SIDEMENU = "SideMenu";
export const MOBILEMENU = "MobileMenu";
